import { ref, watchEffect } from 'vue'
import { useLoginMutation } from '@server/graphql/mutations/loginMutation'
import { ILoginInput, IFetchLoginReturn, ILoginData } from '@types'
import { saveTokens } from '~/utils/apolloTokenUtils'

/**
 * Função para executar a mutação de login.
 * @param loginInput As variáveis necessárias para a mutação.
 * @returns Um objeto com referências reativas para os dados, estado de carregamento, erros e função de parada.
 */
const mutateLogin = (loginInput: ILoginInput): IFetchLoginReturn => {
  const data = ref<ILoginData | null>(null)
  const loading = ref<boolean>(false)
  const error = ref<string | null>(null)
  const { mutate, onDone, onError } = useLoginMutation()

  const execute = async () => {
    loading.value = true
    try {
      await mutate({ loginInput })
    } catch (err) {
      error.value = (err as Error).message
      loading.value = false
    }
  }

  const stop = watchEffect(() => {
    onDone(({ data: mutationData }) => {
      data.value = mutationData?.login.payload

      saveTokens({
        access: data.value?.accessToken,
        refresh: data.value?.refreshToken
      })

      loading.value = false
    })

    onError(mutationError => {
      error.value = mutationError.graphQLErrors[0]
      loading.value = false
    })
  })

  return { execute, data, loading, error, stop }
}

export default mutateLogin
